/*
 * Copyright © HatioLab Inc. All rights reserved.
 */

import { Container, sceneComponent } from '@hatiolab/things-scene'

const NATURE = {
  mutable: false,
  resizable: true,
  rotatable: true,
  properties: []
}

@sceneComponent('container')
export default class StaticContainer extends Container {
  // things-scene 의 `declare const Container_base` 패턴이 base 인스턴스 타입의 accessor
  // 정보를 object-type property 로 평탄화하여 TS2611 발생. operato-scene 은 position
  // override 케이스가 없어 미발현, fmsim 만 해당. things-scene 측 mixin 타입 패턴이
  // 개선되면 제거.
  // @ts-expect-error TS2611
  get position() {
    return 'static'
  }

  get nature() {
    return NATURE
  }
}
